import { ofType } from "redux-observable";
import { filter, ignoreElements, retry, switchMap } from "rxjs/operators";
import { ChatConstants } from "../../../constants/ChatConstants";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { TypeActionChat } from "../actionChat";
export var epicPostInChatRoom = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionChat.PostInChatRoom), filter(function (action) {
        return (action.message !== undefined &&
            action.message.trim().length >= ChatConstants.MinimumTextCharacters);
    }), switchMap(function (action) {
        var state = state$.value;
        var chatRoomId = state.chatInfo.chatRoom.chatRoomId;
        return deps
            .chatNetSend({
            id: CommandCode.PostInChatRoom,
            props: {
                chatMessage: action.message
                    .trim()
                    .slice(0, ChatConstants.MaximumTextCharacters),
                chatRoomId: chatRoomId,
            },
        })
            .pipe(retry(), ignoreElements());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/chat/epics/epicPostInChatRoom.ts
// module id = 1795
// module chunks = 3